import { setAuthState, switchAccounts } from '../repositories/auth.actions';
import {
  authConfigSnapshot,
  authUserSnapshot,
} from '../repositories/auth.repository';
import { dispatch } from '@ngneat/effects';

/**
 * Use this function to attempt to switch the User to a different Account
 * @param alias The Alias of the Account to switch to
 */
export const switchAccount = (alias: string) => {
  const { authToken } = authUserSnapshot();
  const { trimbleMapsAppName } = authConfigSnapshot().trimbleIdentity;
  dispatch(
    setAuthState({
      authState: {
        state: 'switching-account',
      },
    })
  );
  dispatch(switchAccounts({ authToken, alias, product: trimbleMapsAppName }));
};
